import { ENDPOINT_ATTACHMENTS } from '../config'
import type { AxiosResponse } from 'axios'
import AuthAxios from '@/lib/api/axios/AuthAxios'

export interface PresignedUploadUrlRequest {
  fileName: string
  fileType: string
  fileSizeBytes: number
  description?: string
}

export interface PresignedUploadUrlResponse {
  attachmentId: string
  storageKey: string
  uploadUrl: string
  expiresInSeconds: number
}

/**
 * Request a presigned URL to upload a file directly to R2
 */
const getPresignedUploadUrl = async (
  workspaceId: string,
  entityType: string,
  entityId: string,
  request: PresignedUploadUrlRequest,
): Promise<PresignedUploadUrlResponse> => {
  const endpoint = `${ENDPOINT_ATTACHMENTS(workspaceId, entityType, entityId)}/presigned-url`

  const response: AxiosResponse<PresignedUploadUrlResponse> =
    await AuthAxios.post(endpoint, {
      version: 1,
      data: request,
    })

  return response.data
}

export default getPresignedUploadUrl
